import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-bunker-list-toolbar',
  templateUrl: './bunker-list-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule,
    AuthenticationModule,
    MatButtonModule,
  ]
})
export class BunkerListToolbarComponent {

  constructor(private _router: Router) {
  }

  addBunker() {
    this._router.navigate(['vessels/bunker']).then();
  }
}
